import React from "react";
import VideoBoxGrid from "../components/video_box_grid";
import styles from "./onlinetv_hero.module.scss";

export const OnlinetvHero = (props) => {
  return (
    <section className={styles.section_blog_hero}>
      <div className="container">
        <div className={styles.wrapper}>
          {props.title && <h1 className={styles.title}>{props.title}</h1>}
          <div className={styles.blog_hero_wrapper}>
            {new Array(5).fill(1).map((course, i) => (
              <VideoBoxGrid key={i} spanTwo={i === 0} metaTop />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlinetvHero;
